export default __webpack_public_path__ + "static/media/home-digital-agency-img-10.5563c3aa.jpg";